import styled from 'styled-components/macro';
import { Link } from '@yme/components/Link';
import { RegularTextLevel3 } from '@yme/tokens/typography';
export const ImageWrapperStyled = styled.div `
  height: auto;
  margin-bottom: 16px;
`;
export const ElementLinkStyled = styled(Link) `
  text-decoration: none;
`;
export const PriceStyled = styled(RegularTextLevel3) `
  margin-top: 4px;
`;
